import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import './style.less';

interface IError {
  text?: string,
  click?: any
}

@Component
export default class Error extends tsx.Component<IError> {
  
  @Prop() public text?: string
  @Prop({default: () => {}}) public click?: any
  
  render() {
    const {click = () => {}, } = this.$props
    return (
      <div class="phone-error">
        <div class="phone-error-bg">
          <img style="width: 30.85714vw" src={require('../../assets/img/phone-err-icon.png')} alt=""/>
        </div>
        <span class="phone-error-text">{this.$props.text}</span>
        <div onClick={click} class="phone-error-button">退出云手机</div>
      </div>
    )
  }
  
}